import {useEffect, useState} from "react";
import {Drawer, Pagination } from "antd";
import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {httpStatus} from "../../../lib/createRequestSaga";
import {errorHandle, onExporting} from "../../../lib/BuilderUtils";
import './style.scss';
import NormalLoading from "../NormalLoading";
import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    HeaderFilter,
    Item,
    LoadPanel,
    Pager,
    Paging,
    Toolbar
} from "devextreme-react/data-grid";
const StudyStructureResetHistory = ({showResetHistory, onHistoryCloseDrawer, reload}) => {

    const [resetHistoryList, setResetHistoryList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataGrid, setDataGrid] = useState(null);

    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        setLoading(true);
        (async () => {
            try {
                const {status, data} = await axios.get(`/api/builder/studies/${params?.sid}/stratification/audit/reset`);

                if(status === httpStatus.ok) {
                    setResetHistoryList(data?.resetHistoryList)
                }

            } catch (e) {
                errorHandle(e, navigate, '');
            }
            setLoading(false);
        })()

    }, [reload])

    return (
        <>
            <Drawer
                title={"Reset History"}
                placement="right"
                size={'large'}
                onClose={() => onHistoryCloseDrawer('reset')}
                open={showResetHistory}
            >
                {
                    loading?(
                        <NormalLoading />
                    ):(
                        <>
                            <DataGrid dataSource={resetHistoryList}
                                      height={'600'}
                                      id={'girdResetHistory'}
                                      ref={(ref) => {
                                          setDataGrid(ref);
                                      }}
                                      allowedPageSizes={true}
                                      allowColumnResizing={false}
                                      columnMinWidth={50}
                                      columnAutoWidth={true}
                                      showColumnLines={true}
                                      showRowLines={true}
                                      showBorders={true}
                                      hoverStateEnabled={true}
                                      allowColumnReordering={true}
                                      keyExpr={'id'}
                                      onExporting={(e) => onExporting(e, 'Studies',
                                          ({gridCell, excelCell}) => {
                                              if (gridCell.column.dataField === 'action') {
                                                  excelCell.value = '';
                                              }
                                          }
                                      )}>
                                <Column dataField={'num'} caption={('No')} fixed={true} fixedPosition={'left'}
                                        width={'60px'}
                                        cellTemplate={(cellElement, cellInfo) => {
                                            const dataGrid = cellInfo.component;
                                            const num = dataGrid.pageIndex() * dataGrid.pageSize() + cellInfo.rowIndex;
                                            cellElement.innerText= num + 1;
                                        }}
                                />
                                <Column dataField={'user.username'} caption={('User')} dataType={'string'}/>
                                <Column dataField={'resetDate'} dataType={'datetime'} format={'yyyy-MM-dd HH:mm:ss'}/>
                                <Toolbar>
                                    <Item name={'columnChooserButton'}/>
                                    <Item name={'exportButton'}/>
                                </Toolbar>
                                <ColumnChooser enabled={true}/>
                                <Export enabled={true} allowExportSelectedData={false}/>
                                <LoadPanel enabled={true}/>
                                <HeaderFilter visible={true} allowSearch={true}/>
                                <FilterRow visible={true} applyFilter={'auto'}/>
                                <Paging defaultPageSize={10}/>
                                <Pager
                                    visible={true}
                                    displayMode={'compact'}
                                    allowedPageSizes={[10, 20, 30, 50]}
                                    showPageSizeSelector={true}
                                    showInfo={true}
                                />
                            </DataGrid>
                        </>
                    )
                }
            </Drawer>
        </>
    )
}

export default StudyStructureResetHistory;